exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-3-1!../../../node_modules/postcss-loader/src/index.js??postcss!antd/dist/antd.css"), "");

// Module
exports.push([module.id, ".flex-grid {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;   \n  }\n\n\n  .col {\n    flex-grow: 1;\n  }\n  .card-item{\n    margin: 25px;\n    max-width: 300px;\n    height: 100%;\n    /* width: 100%; */\n  }\n", ""]);

